import React from 'react';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

function tieneEstadosSiguientes(productoId, selectedId, siguientes) {    
    const findSiguiente = siguientes.find(s => s.ProductoId == productoId && s.DeliveryEstadoId == selectedId);
    return findSiguiente !== undefined;  
}

const TipoPlasticoCambioEstado = ({ seleccionados, nombreEstado, seleccionarFn, idEstado, tiposPlastico, siguientes }) => {

    return (
    <span>
       {tiposPlastico.map(t =>
          <BotonCambioEstado idEstado={idEstado} seleccionados={seleccionados} nombreEstado={nombreEstado} seleccionarFn={seleccionarFn} tipo={t} siguientes={siguientes} />
       )}
    </span>
    );
}

const BotonCambioEstado = ({ seleccionados, nombreEstado, seleccionarFn, idEstado, tipo, siguientes }) => {

    const seleccionadosEstado = seleccionados[nombreEstado] === undefined ? [] : seleccionados[nombreEstado];
    const tipoFiltrado = seleccionadosEstado.filter(s => s.tipo == tipo.Descripcion);

    if (seleccionadosEstado.length <= 0 || tipoFiltrado.length <= 0)
        return null;

    const sinCambioManual = tipo.Codigo === "55" && (idEstado === 1 || idEstado === 2);
    const sinEstadosSiguientes = !tieneEstadosSiguientes(tipo.Id, idEstado, siguientes);
    
    if (sinCambioManual || sinEstadosSiguientes) {
        return (
        <GrupoEstadoBoxDisabled
            nombreEstado={nombreEstado}
            seleccionados={tipoFiltrado}
            tipo={tipo.Descripcion}
            sinEstadosSiguientes={sinEstadosSiguientes}
            sinCambioManual={sinCambioManual}
        />
        );
    }
      

    return (<GrupoEstadoBox nombreEstado={nombreEstado} seleccionados={tipoFiltrado} seleccionarFn={seleccionarFn} tipo={tipo.Descripcion} tipoId={tipo.Id}  />);

}

const GrupoEstadoBox = ({ nombreEstado, seleccionados, tipo, seleccionarFn, tipoId }) => {

    
    return (
    <div className="TipoPlasticoCaja Enabled" >
      <div onClick={() => seleccionarFn(nombreEstado, seleccionados, tipoId)} >
        <span className="Texto1">{seleccionados.length}</span> {tipo}
        <span className="TipoPlasticoEstado">{nombreEstado}</span>
        <span className="ti ti-angle-right FlechaDer"></span>
      </div>
      <br />
    </div>    
    );
}

const MensajeDeshabilitado = ({ nombreEstado, sinEstadosSiguientes, sinCambioManual }) => {

    if (sinCambioManual)
        return <span>Los pl&aacute;sticos {nombreEstado} no pueden cambiarse de estado manualmente.</span>;
    else
    {
        if (sinEstadosSiguientes)
            return <span>No tiene permisos para cambiar los pl&aacute;sticos {nombreEstado} de estado.</span>;
    }
}

const GrupoEstadoBoxDisabled = ({ nombreEstado, seleccionados, tipo, sinEstadosSiguientes, sinCambioManual }) => {
    
    return (
    <Tooltip
       placement="topRight"
       trigger={['hover']}
       overlay={<MensajeDeshabilitado nombreEstado={nombreEstado} sinEstadosSiguientes={sinEstadosSiguientes} sinCambioManual={sinCambioManual} />}
       destroyTooltipOnHide={true}
    >
      <div className="TipoPlasticoCaja Disabled" >
         <div>
           <span className="Texto1">{seleccionados.length}</span> {tipo}
           <span className="TipoPlasticoEstado">{nombreEstado}</span>
           <span className="ti ti-angle-right FlechaDer"></span>
        </div>        
         <br />
      </div>
   </Tooltip>        
   );
}

const MensajeDistintoEstado = ({ seleccionados }) => {

    // Discriminar por seleccionados si se eligio m�s de un estado. 

    return (
    <div>
        <p className="CambiarTarjetasPinesText">
         Ha seleccionado tarjetas y/o pines que pertenecen a distintos estados, recuerde que solo puede seleccionar uno de estos para cambiar:
        </p>
    </div>     
   );

}

const GroupList = ({ seleccionados, seleccionarFn, total, estados, tiposPlastico, siguientes }) => {

    return (
    <div>

        <MensajeDistintoEstado seleccionados={seleccionados} />

        <div className="CambiarEstadoLabelContainer">
        {estados.map(e =>
            <TipoPlasticoCambioEstado
                siguientes={siguientes}
                idEstado={e.Id}
                seleccionados={seleccionados}
                nombreEstado={e.Descripcion}
                seleccionarFn={seleccionarFn}
                tiposPlastico={tiposPlastico}
            />
        )}
        </div>

    </div>
    );
}

export default GroupList;